import { createKernelCanvasArtifact } from "../kernelCanvasArtifact.js";
import { BUILTIN_KERNELS } from "./builtinKernels.js";
import { BUILTIN_CANVASES } from "./builtinCanvases.js";
import {
    BUILTIN_CANVAS_PORTABLE_IDS,
    BUILTIN_KERNEL_PORTABLE_IDS,
} from "./bundledArtifactIds.js";

export const BUNDLED_KERNEL_CANVAS_ARTIFACT = createKernelCanvasArtifact({
    kernels: BUILTIN_KERNELS.map((kernel) => ({
        ...kernel,
        id: BUILTIN_KERNEL_PORTABLE_IDS[kernel.command],
    })),
    canvases: BUILTIN_CANVASES.map((canvas) => ({
        ...canvas,
        id: BUILTIN_CANVAS_PORTABLE_IDS[canvas.slug],
        rows: canvas.rows.map((row) => ({
            ...row,
            cells: row.cells.map((cell) => ({
                ...cell,
                kernel_id: BUILTIN_KERNEL_PORTABLE_IDS[cell.command],
            })),
        })),
    })),
});
